import { db } from '../client/index';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc, query, where } from 'firebase/firestore/lite';
import { format, add } from 'date-fns';

const expensesCollection = collection(db, 'expenses');

export const getExpenses = async (date) => {
  try {
    const day = format(date, 'yyyy-MM-dd');
    const dayNext = format(add(date, { days: 1 }), 'yyyy-MM-dd');
    const expensesQuery = query(expensesCollection, where('date', '>=', day), where('date', '<', dayNext));
    const expensesSnapshot = (await getDocs(expensesQuery)).docs;
    const expensesItems = expensesSnapshot.map(expense => ({
      ...expense.data(),
      id: expense.ref.id
    }));
    return expensesItems;
  } catch (err) {
    return err;
  }
}

export const getExpense = async (id) => {
  try {
    const expenseSnapshot = doc(db, 'expenses', id);
    const expenseItem = await getDoc(expenseSnapshot);
    return expenseItem.exists() ? expenseItem.data() : null;
  } catch (err) {
    return err;
  }
}

export const createExpense = async (expense) => {
  try {
    const { id } = await addDoc(expensesCollection, expense);
    const expenseAdded = { id, ...expense };
    return expenseAdded;
  } catch (err) {
    return err;
  }
}

export const updateExpense = async (id, expense) => {
  try {
    const expenseRef = doc(db, 'expenses', id);
    await updateDoc(expenseRef, expense);
    return { id, ...expense };
  } catch (err) {
    return err;
  }
}

export const deleteExpense = async (id) => {
  try {
    const expenseRef = doc(db, 'expenses', id);
    await deleteDoc(expenseRef);
    return id;
  } catch (err) {
    return err;
  }
}